export default __webpack_public_path__ + "static/Fly3-4c74ed94b434ecc3489c85e1662aa421.mp3";